<template>
  <div>
    Aguarde...
  </div>
</template>
<script>
  import Vue from 'vue'
  export default {
    mounted() {
      this.$router.push("/visits/" + this.$route.params.id)
    }
  }  
</script>


// WEBPACK FOOTER //
// src/components/RefreshVisitView.vue